module.exports = __webpack_public_path__ + "static/homepage-modern-web-e28cc683dc3810538dc3842e0788c495.png";